import { Dialog, DialogTitle, DialogContent, DialogActions, 
  Button, Box, Snackbar, Alert, TextField, Stack,Typography}
  from "@mui/material";
import * as React from "react";
import { post } from 'aws-amplify/api';

export default function UserProfileDialog(props: {
    open: boolean,
    handleClose: () => void,
    email: string,
  }) {
  const [snackInfo, setSnackInfo] = React.useState<any>({
    open: false, message: '', severity: 'info'
  });

  const [email, setEmail] = React.useState('');
  const [emailHelper, setEmailHelper] = React.useState<string>('');

  React.useEffect(() => {
    setEmail(props.email);
  }, [props.open]);

  React.useEffect(() => {
    if (!email) {
      setEmailHelper('Please enter an email address');
    } else if (!isValidEmail(email)) {
      setEmailHelper('Invalid email address');
    } else {
      setEmailHelper('');
    }
  }, [email]);

  const handleUpdate = () => {

    const postOperation = post({
      apiName: 'cabb',
      path: '/update_user_email',
      options: {
        body: { email: email },
        headers: {'content-type': 'application/json'}
      }
    });
    
    postOperation.response
      .then(response => response.body.json())
      .then((response: any) => {
      if (response['status'] === 'success') {
          setSnackInfo({open: true, message: 'Email updated', severity: 'info'});
      } else {
        const message = response['message'];
        if (message) {
          setSnackInfo({open: true, message: message, severity: 'error'});
        }
      }
    }).catch((err: Error) => {
      setSnackInfo({
        open: true,
        message: 'Could not update user email: ' + err.message,
        severity: 'error'
      });
    });
  }

  const isValidEmail = (email: string): boolean => {
    // A common regex for email validation
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return emailRegex.test(email);
  };

  return (
    <Dialog open={props.open}
      aria-labelledby="user-profile-dialog-title"
      onClose={props.handleClose}
      maxWidth="sm" fullWidth>
      <DialogTitle id="user-profile-dialog-title">
        User Profile
      </DialogTitle>
      <DialogContent sx={{
        display: 'flex',
        flexDirection: 'column',
      }}>
        <Stack display={'flex'} flexDirection={'column'}
         paddingTop={'10px'}
         spacing={2} sx={{height: '100%'}}
        >
          <TextField fullWidth id="email-address" variant="outlined"
            error={Boolean(emailHelper)}
            sx={{height: '100px'}}
            helperText={emailHelper}
            label="User email address" 
            value={email} onChange={(e) => setEmail(e.target.value)} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button autoFocus 
          onClick={handleUpdate}>
          Update
        </Button>
        <Button onClick={props.handleClose}>
          Cancel
        </Button>
      </DialogActions>

      <Snackbar
        role = "alert"
        aria-label = {"Alert message"}
        open={snackInfo['open']}
        autoHideDuration={6000}
        onClose={e => setSnackInfo({open: false, message: ''})}
      >
        <Alert severity={snackInfo['severity']}>
          {snackInfo['message']}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};
